class BasicProfilePresenter {
    constructor(usecase, actions) {
        this.usecase = usecase;
        this.actions = actions;
    }
    getClientDetailsData(req) {
        this.actions.clientDetails.hideError();
        this.actions.clientDetails.loader();
        this.usecase.clientDetails.execute({
            onSuccess: (data) => {
                if (data)
                    this.actions.clientDetails.getClientDetailsData(data);
                this.actions.clientDetails.stopLoader();
            },
            onError: (error) => {
                this.actions.clientDetails.setError({ isOpen: true, error });
                this.actions.clientDetails.stopLoader();
            },
        }, req);
    }
    getProfilePicData(req) {
        this.actions.getProfilePic.hideError();
        this.actions.getProfilePic.loader();
        this.usecase.GetProfilePic.execute({
            onSuccess: (data) => {
                if (data)
                    this.actions.getProfilePic.getProfilePicData(data);
                this.actions.clientDetails.stopLoader();
            },
            onError: (error) => {
                this.actions.clientDetails.setError({ isOpen: true, error });
                this.actions.clientDetails.stopLoader();
            },
        }, req);
    }
    getRegisterdDeviceData(req) {
        this.actions.getRegisteredDeviceDetails.hideError();
        this.actions.getRegisteredDeviceDetails.loader();
        this.usecase.getRegisteredDeviceDetails.execute({
            onSuccess: (data) => {
                if (data)
                    this.actions.getRegisteredDeviceDetails.getRegisterdDeviceData(data);
                this.actions.getRegisteredDeviceDetails.stopLoader();
            },
            onError: (error) => {
                this.actions.getRegisteredDeviceDetails.setError({
                    isOpen: true,
                    error,
                });
                this.actions.getRegisteredDeviceDetails.stopLoader();
            },
        }, req);
    }
    DeleteProfilePicData(req) {
        return new Promise((resolve, reject) => {
            this.usecase.deleteProfilePic.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(error);
                },
            }, req);
        });
    }
    deRegisterDeviceData(req) {
        return new Promise((resolve, reject) => {
            this.usecase.deRegisterDeviceDetails.execute({
                onSuccess: (data) => {
                    resolve(data);
                    resolve(data);
                },
                onError: (error) => {
                    reject(error);
                },
            }, req);
        });
    }
    SaveProfilePicData(req) {
        return new Promise((resolve, reject) => {
            this.usecase.saveProfilePic.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(error);
                },
            }, req);
        });
    }
    registerDeviceData(req) {
        return new Promise((resolve, reject) => {
            this.usecase.registerDeviceDetails.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(error);
                },
            }, req);
        });
    }
    advisorRatingDetailsData(req) {
        return new Promise((resolve, reject) => {
            this.usecase.advisorRating.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(error);
                },
            }, req);
        });
    }
    nomineeDetailsData(req) {
        return new Promise((resolve, reject) => {
            this.usecase.nomineeDetails.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(error);
                },
            }, req);
        });
    }
    getBrokerageSegmentData(req) {
        let useCase = this.usecase.getBrokerageSegmentDetails;
        return new Promise((resolve, reject) => {
            useCase.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(error);
                },
            }, req);
        });
    }
    getRmDetailsData() {
        this.actions.getRmDetails.hideError();
        this.actions.getRmDetails.loader();
        this.usecase.getRmDetails.execute({
            onSuccess: (data) => {
                if (data)
                    this.actions.getRmDetails.getRmDetailsData(data);
                this.actions.getRmDetails.stopLoader();
            },
            onError: (error) => {
                this.actions.getRmDetails.setError({ isOpen: true, error });
                this.actions.getRmDetails.stopLoader();
            },
        }, null);
    }
    whatsappContentDetailsData(req) {
        let useCase = this.usecase.whatsappConsent;
        return new Promise((resolve, reject) => {
            useCase.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(error);
                },
            }, req);
        });
    }
    downloadKYCData(req) {
        return new Promise((resolve, reject) => {
            this.usecase.downloadKYCData.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(error);
                },
            }, req);
        });
    }
    defaultExchangeData(req) {
        return new Promise((resolve, reject) => {
            this.usecase.DefaultExchange.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(error);
                },
            }, req);
        });
    }
    wealthAdvisorData(req) {
        return new Promise((resolve, reject) => {
            this.usecase.wealthAdvisor.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(error);
                },
            }, req);
        });
    }
    saveLeadData(req) {
        return new Promise((resolve, reject) => {
            this.usecase.saveLead.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(error);
                },
            }, req);
        });
    }
    mandateCalendarData(req) {
        return new Promise((resolve, reject) => {
            this.usecase.mandateCalendar.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(error);
                },
            }, req);
        });
    }
    deleteUpiData(req) {
        return new Promise((resolve, reject) => {
            this.usecase.deleteUpi.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(error);
                },
            }, req);
        });
    }
}
export default BasicProfilePresenter;
